import i18n from "../../../i18n";

export function getBasePath(currentPathname) {
    const segments = currentPathname.split('/').filter(segment => segment);
    if (segments[0] && segments[0].length === 2) {
        segments.shift();
    }
    return segments.join('/');
}

export function showMultiLingualText(text, altText = null, showFirstLanguage = false) {
    function isObject(value) {
        return typeof value === 'object' && value !== null && !Array.isArray(value);
    }

    if (isObject(text)) {
        if (i18n.language in text && text[i18n.language]) {
            return text[i18n.language];
        }

        // If the languageCode is not found, return the value associated with the first key
        if (altText) {
            return altText;
        }

        if (showFirstLanguage) {
            const firstKey = Object.keys(text)[0];
            if (text[firstKey]) {
                return text[firstKey];
            }
        }

        return "";
    }

    return altText || text || "";
}
